import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Table,
  ProgressBar,
  Button,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Header from "../components/Header";
import { Navigate } from "react-router-dom";
import { Calender } from "../components/Forms";
import moment from "moment";
import fan from "../fan.png";
import tower from "../tower.png";
import "../css/Dashboard.css";
const DashBoard = () => {
  const [loading, setLoading] = useState(true);
  const [dgrdailydate, setDgrdailydate] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [userID, setUserID] = useState("");

  // Fetch data for the selected date
  const handleSubmit = async (event, id = userID) => {
    if (event) {
      event.preventDefault(); // Prevent the default form submission behavior if event exists
    }

    setLoading(true); // Indicate that loading has started

    try {
      const customerId = id;

      if (!customerId) throw new Error("User ID is missing locally");

      const formattedDate = moment(selectedDate).format("YYYY-MM-DD"); // Format the selected date

      const response = await fetch(
        "https://api.srivarugreenenergy.com/customerapi/dashboard/daily.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: customerId,
            filter_date: formattedDate, // Pass the selected date to the API
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      setLoading(false); // Stop loading

      if (responseData.status === 200) {

        setDgrdailydate(responseData); // Update state with the fetched data
      } else {
        throw new Error(responseData.msg); // Handle non-successful status codes
      }
    } catch (error) {
      setLoading(false); // Ensure loading is stopped in case of an error
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetch(
      "https://api.srivarugreenenergy.com/customerapi/auth/check-session.php",
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "Authenticated") {
          setUserID(data.customer_id);
          // Sync localStorage for Header component
          localStorage.setItem("session", "active");
          localStorage.setItem("customerId", data.customer_id);
          if (data.customer_name) {
            localStorage.setItem("customerName", data.customer_name);
          }
          window.dispatchEvent(new Event("authChange"));
          handleSubmit(null, data.customer_id);
        } else {
          window.location.replace("https://srivarugreenenergy.com");
        }
      })
      .catch((error) => {
        console.error("Error checking session:", error);
      });
  }, []);

  // Handle date change
  const handleDateChange = (date) => {
    setSelectedDate(date); // Update selectedDate when date changes
  };

  const formatDate = (date) => moment(date).format("DD-MM-YYYY");
  const formatNumber = (number) => number.toLocaleString();

  if (!isLoggedIn) return <Navigate to="/" replace />;



  const sortData = (data) => {
    return data.sort((a, b) => {
      const regexPureNumbers = /^\d+$/;
      const regexLettersNumbers = /^[A-Za-z]{2,5}\d+$/;
      const aValue = a.wtg_no;
      const bValue = b.wtg_no;
      const aIsNumber = regexPureNumbers.test(aValue);
      const bIsNumber = regexPureNumbers.test(bValue);
      const aIsAlphaNum = regexLettersNumbers.test(aValue);
      const bIsAlphaNum = regexLettersNumbers.test(bValue);

      if (aIsNumber && bIsNumber) return parseInt(aValue) - parseInt(bValue);
      else if (aIsAlphaNum && bIsAlphaNum)
        return aValue.localeCompare(bValue, undefined, { numeric: true });
      else if (aIsNumber) return -1;
      else return 1;
    });
  };
  return (
    <>
      <div id="main">
        <Container fluid className="main my-3">
          <Row className="d-flex justify-content-center">
            <Col
              lg="4"
              md="8"
              sm="12"
              xs="12"
              className="py-3 d-flex justify-content-center"
            >
              <form onSubmit={handleSubmit} className="w-100 d-flex">
                <div className="w-100 m-1">
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)} // Ensure you have a way to update selectedDate
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                  />
                </div>
                <div className="w-100 text-center">
                  <span className="mx-2">
                    <Button type="submit" className="submit-btn bold">
                      Submit
                    </Button>
                  </span>
                </div>
              </form>
            </Col>
          </Row>
        </Container>
      </div>

      <div id="mainn">
        <Header />
        <div className="bg-white my-0 rounded">
          <Container fluid>
            <Row>
              <Col lg="4" md="6" xs="12" className="py-3">
                <div className="counterturbine">
                  <div className="text-end">
                    <span className="m-4 responsive-font">
                      {dgrdailydate?.most_recent_date &&
                        formatDate(dgrdailydate.most_recent_date)}
                    </span>
                  </div>
                  <div className="d-flex align-items-center m-2">
                    <div className="position-relative">
                      <img
                        src={fan}
                        alt="Rotating Icon"
                        className="rotate position-absolute"
                      />
                      <img
                        src={tower}
                        alt="Tower Icon"
                        className="position-absolute tower"
                      />
                    </div>
                    <div className="m-4">
                      <span className="responsive-font">
                        Total Production :{" "}
                        {formatNumber(dgrdailydate.daily_production || 0)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg="4" md="6" xs="12" className="py-3">
                <div className="counterturbine">
                  <div className="text-end">
                    <span className="m-4  responsive-font">
                      {dgrdailydate.month}
                    </span>
                  </div>
                  <div className="d-flex align-items-center m-2">
                    <div className="position-relative">
                      <img
                        src={fan}
                        alt="Rotating Icon"
                        className="rotate position-absolute"
                      />
                      <img
                        src={tower}
                        alt="Tower Icon"
                        className="position-absolute tower"
                      />
                    </div>
                    <div className="m-4">
                      <span className=" responsive-font">
                        Total Production :{" "}
                        {formatNumber(dgrdailydate.monthly_production || 0)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg="4" md="6" xs="12" className="py-3">
                <div className="counterturbine">
                  <div className="text-end">
                    <span className="m-4 responsive-font">
                      {dgrdailydate.current_year}
                    </span>
                  </div>
                  <div className="d-flex align-items-center m-2">

                    <div className="position-relative">
                      <img
                        src={fan}
                        alt="Rotating Icon"
                        className="rotate position-absolute"
                      />
                      <img
                        src={tower}
                        alt="Tower Icon"
                        className="position-absolute tower"
                      />
                    </div>
                    <div className="m-4">
                      <span className=" responsive-font">
                        Total Production :{" "}
                        {formatNumber(dgrdailydate.yearly_production || 0)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              {/* Other columns can remain the same */}
            </Row>
          </Container>
          <div className="m-3">
            <Row>
              <Col lg={3} className="mb-5">
                <div className="h5 text-center mb-2">
                  {dgrdailydate?.most_recent_date &&
                    formatDate(dgrdailydate.most_recent_date)}
                </div>
                <div
                  style={{
                    overflow: "auto",
                    maxHeight: "590px",
                    maxWidth: "1880px",
                  }}
                >
                  <Table striped bordered hover>
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                        backgroundColor: "#fff",
                      }}
                    >
                      <tr>
                        <th>S.No</th>
                        <th>WEG No.</th>
                        <th>Loc. No</th>
                        <th>Total Production</th>
                      </tr>
                    </thead>
                    <tbody>
                      {" "}

                      {sortData(dgrdailydate.daily_data || []).map(
                        (data, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>

                            <td>{data.wtg_no}</td>
                            <td>{data.loc_no}</td>

                            <td>
                              {data.total_production
                                ? formatNumber(data.total_production)
                                : "-"}
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>
              <Col lg={3}>
                <div className="h5 text-center mb-2">{dgrdailydate.month}</div>
                <div
                  style={{
                    overflow: "auto",
                    maxHeight: "590px",
                    maxWidth: "1880px",
                  }}
                >
                  <Table striped bordered hover>
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                        backgroundColor: "#fff",
                      }}
                    >
                      <tr>
                        <th>S.No</th>
                        <th>WEG No.</th>
                        <th>Loc. No</th>
                        <th>Total Production</th>
                      </tr>
                    </thead>
                    <tbody>

                      {sortData(dgrdailydate.monthly || []).map(
                        (data, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.wtg_no}</td>
                            <td>{data.loc_no}</td>
                            <td>
                              {formatNumber(data.total_production || "-")}
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>
              <Col lg={3}>
                <div
                  className="h5 text-center mb-2"
                  style={{ fontSize: "18px" }}
                >
                  Machine Availability -{" "}
                  {dgrdailydate?.most_recent_date &&
                    formatDate(dgrdailydate.most_recent_date)}{" "}
                </div>
                <div
                  style={{
                    overflow: "auto",
                    maxHeight: "590px",
                    maxWidth: "1880px",
                  }}
                >
                  <Table striped bordered hover>
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                        backgroundColor: "#fff",
                      }}
                    >
                      <tr>
                        <th>S.No</th>
                        <th>WEG No.</th>
                        <th>Loc. No</th>
                        <th>Machine Availability</th>
                      </tr>
                    </thead>
                    <tbody>

                      {sortData(dgrdailydate.daily_data || []).map(
                        (data, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.wtg_no}</td>
                            <td>{data.loc_no}</td>
                            <td>
                              {data.machine_availability ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <ProgressBar
                                      now={parseFloat(
                                        data.machine_availability,
                                      )}
                                      label={`${data.machine_availability}%`}
                                      variant="success"
                                    />
                                  </div>
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>
              <Col lg={3}>
                <div
                  className="h5 text-center mb-2"
                  style={{ fontSize: "18px" }}
                >
                  Grid Availability -{" "}
                  {dgrdailydate?.most_recent_date &&
                    formatDate(dgrdailydate.most_recent_date)}{" "}
                </div>
                <div
                  style={{
                    overflow: "auto",
                    maxHeight: "590px",
                    maxWidth: "1880px",
                  }}
                >
                  <Table striped bordered hover>
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                        backgroundColor: "#fff",
                      }}
                    >
                      <tr>
                        <th>S.No</th>
                        <th>WEG No.</th>
                        <th>Loc. No</th>
                        <th>Grid Availability</th>
                      </tr>
                    </thead>
                    <tbody>

                      {sortData(dgrdailydate.daily_data || []).map(
                        (data, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.wtg_no}</td>
                            <td>{data.loc_no}</td>

                            <td>
                              {data.grid_availability ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <ProgressBar
                                      now={parseFloat(data.grid_availability)}
                                      label={`${data.grid_availability}%`}
                                      variant="success"
                                    />
                                  </div>
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
          {/* Other sections can remain the same */}
        </div>
      </div>
    </>
  );
};

export default DashBoard;

